import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-loading-backoffice',
  templateUrl: './loading-backoffice.component.html',
  styleUrl: './loading-backoffice.component.css'
})
export class LoadingBackofficeComponent {

  @Input() visible: boolean = false;
  @Output() close = new EventEmitter<boolean>();

  onClose() {
    this.visible = false;
    this.close.emit(this.visible);
  }

}
